import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import ChatContext from "./ChatContext";
import Icon from "components/common_components/Icon";
import Status from "components/common_components/Status";

function MessageSender() {
    const { selectedConversation } = useContext(ChatContext);
    const { user } = useSelector((state) => state.Login);
    const [newMessage, setNewMessage] = useState("");

    const onNewMessageChange = (event) => {
        setNewMessage(event.target.value);
    };

    const sendMessage = (event) => {
        event.preventDefault();
        if (newMessage && typeof newMessage === "string" && newMessage.trim().length > 0) {
            selectedConversation.sendMessage(newMessage, {
                senderUserEmail: user.email
            });
            setNewMessage("");
        }
    };

    const onInputKeyDown = (event) => {
        if (event.key === "Enter") {
            sendMessage(event);
        }
    };

    const conversationState = selectedConversation.state.current;

    // Closed is terminal/read-only in Twilio: no input, just a clear status badge.
    if (conversationState === "closed") {
        return (
            <div className="conversation-status">
                <Status id="closed" withIcon />
            </div>
        );
    }

    // Initializing can't be used for message sending yet (Twilio error 50386): disable the input.
    // active/inactive stay usable — sending on an inactive conversation reactivates it.
    const isInitializing = conversationState === "initializing";

    return (
        <>
            <input
                type="text"
                className="write-message"
                value={newMessage}
                onChange={onNewMessageChange}
                onKeyDown={onInputKeyDown}
                placeholder={isInitializing ? "Setting up conversation…" : "Type your message here"}
                disabled={isInitializing}
            />
            <button className="send clickable" disabled={isInitializing}>
                <Icon name="paper-plane" color="white" size="md" onClick={sendMessage} aria-hidden="true" />
            </button>
        </>
    );
}

export default MessageSender;